// extracted by mini-css-extract-plugin
export default {"previewBox":"TemplateEditor_previewBox__n5KZH"};